/**
 * Created by pbo on 21/04/16.
 */

angular.module('taric.model.meursing', ['common.helper', 'ngResource', 'common.config']).factory('Meursing', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/meur/meursingitems', {}, {
        queryItems: {
            method: 'GET',
            isArray: false
        },
        querySecondaryItems: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/meur/secondaryMeursingitems'
        },
        getMeursingResult: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/meur/meursingResult'
        }
    });
}).service('MeursingModel', function ($q, Meursing, CommonHelper, CONSTANTS, $translate) {
    var model = this;

    var searchCriteria = {};
    model.reset = function() {
        model.cancelButtonEnabled = false;
        model.from = null;
        model.milkFatList = {"items": []};
        model.milkProteinsList = {"items": []};
        model.starchGlucoseList = {"items": []};
        model.sucroseIsoglucoseList = {"items": []};
        model.meursingResult = {"additionalCode": null};
        model.countriesAndRegions = {"count": 0, "items": []};
        model.dutyMonetaryUnits = {"count": 0, "items": []};
        model.meursingLinks = {"count": 0, "items": []};
        model.initSearchCriteria();
    };

    model.resetSearchResult = function () {
        model.meursingResult = {"additionalCode": null};
    };

    model.initSearchCriteria = function() {
        var p = model.getSearchCriteria();
        p.language = CommonHelper.getLanguageCode($translate.use());
        p.simulationDate = new Date();
        p.dutyCurrency = CONSTANTS.installationCurrency;
        p.country = null;
        p.useAdditionalCode = false;
        p.additionalCode = null;
        p.milkFatId = null;
        p.milkProteinId = null;
        p.starchGlucoseId = null;
        p.sucroseIsoglucoseId = null;
    };

    model.getSearchCriteria = function () {
        return searchCriteria;
    };

    model.initMeursingItemLists = function (simulationDate) {
        var deferred = $q.defer();
        Meursing.queryItems({
            simulationdate: CommonHelper.getRestDateString(simulationDate)
        }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.updateMilkProteinItems = function (milkFatId, simulationDate) {
        var deferred = $q.defer();
        Meursing.querySecondaryItems({
            id: milkFatId,
            simulationdate: CommonHelper.getRestDateString(simulationDate)
        }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.updateSucroseIsoglucoseItems = function (starchGlucoseId, simulationDate) {
        var deferred = $q.defer();
        Meursing.querySecondaryItems({
            id: starchGlucoseId,
            simulationdate: CommonHelper.getRestDateString(simulationDate)
        }, function (result) {
            deferred.resolve(result);
        }, function (error) {
            deferred.reject(error);
        });
        return deferred.promise;
    };

    model.getMeursingResult = function () {
        var deferred = $q.defer();
        var p = model.getSearchCriteria();
        if (p.useAdditionalCode) {
            Meursing.getMeursingResult({
                simulationdate: CommonHelper.getRestDateString(p.simulationDate),
                dutyamountMonetaryunit: p.dutyCurrency,
                countryCode: p.country,
                useAdditionalCode: p.useAdditionalCode,
                additionalCode: p.additionalCode
            }, function (result) {
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        } else {
            Meursing.getMeursingResult({
                simulationdate: CommonHelper.getRestDateString(p.simulationDate),
                dutyamountMonetaryunit: p.dutyCurrency,
                countryCode: p.country,
                useAdditionalCode: p.useAdditionalCode,
                milkFatId: p.milkFatId,
                milkProteinId: p.milkProteinId,
                starchGlucoseId: p.starchGlucoseId,
                sucroseIsoglucoseId: p.sucroseIsoglucoseId
            }, function (result) {
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        }
    };

});



// WEBPACK FOOTER //
// ./app/taric/duties/shared/meursing-model.js